import axios from 'axios';

export default {
  getMenuTree: function () {
    return axios.get(`/api/navigation/menu`);
  },
};
